package io.horion.cv.utils

import com.varabyte.kobweb.compose.ui.graphics.Color
import io.horion.cv.models.JobType

object TypeJobColors {
    val CDD = Color.rgb(29, 64, 174)
    val CDI =  Color.rgb(71, 71, 71)
    val FREELANCE = Color.rgb(254, 122, 1)
    val STAGE = Color.rgb(255, 202, 5)
    val INTERIM = Color.rgb(6, 182, 212)
    val LEARNING = Color.rgb(200, 200, 200)

    fun getColor(type: JobType): Color {
        return when (type) {
            JobType.CDI -> CDI
            JobType.CDD -> CDD
            JobType.FREELANCE -> FREELANCE
            JobType.STAGE -> STAGE
            JobType.INTERIM -> INTERIM
            JobType.LEARNING -> LEARNING
        }
    }
}